import React from 'react';
import Navbar from '@/components/Navbar';
import { useAuth } from '@/lib/auth-context';
import { Outlet } from 'react-router-dom';

export default function AppLayout() {
  const { status } = useAuth();
  const showNav = status === 'signed-in';

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {showNav && <Navbar />}
      <main className={showNav ? 'pt-14 pb-16 md:pb-0' : ''}>
        <Outlet />
      </main>
    </div>
  );
}
